import { render, staticRenderFns } from "./VmcInput.vue?vue&type=template&id=52b37ff8&"
import script from "./VmcInput.vue?vue&type=script&lang=js&"
export * from "./VmcInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports